import React, { useContext, useEffect, useState } from 'react';
import cl from './DealerComision.module.css';   
import { AppContext } from '../../../../providers/appProvider';
import { useCar } from '../../../../hooks/useCar';
import { useNavigate } from 'react-router-dom'; 
import { useTranslation } from 'react-i18next';
import Modal from '../../../UI/Modal/Modal';
import Form from "../../../../assets/Style/Form.module.css";

const dealerCommissionFields = {
    client_price_dealer: {
        label: 'DealerCommissionCar',
        validationKey: 'DealerCommissionMustBeGreaterThanZero',
        defaultValidationMessage: 'Dealer commission must be greater than 0',
    },
    client_price_dealer_transport: {
        label: 'DealerCommissionTransport',
        validationKey: 'DealerTransportCommissionMustBeGreaterThanZero',
        defaultValidationMessage: 'Dealer transport commission must be greater than 0',
    },
};

const DealerComision = ({ id, field = 'client_price_dealer' }) => {

    const { t } = useTranslation();
    const [clientInfoModal, setClientInfoModal] = useState(false);
    const activeField = dealerCommissionFields[field] ? field : 'client_price_dealer';
    const fieldConfig = dealerCommissionFields[activeField];
    
    let navigate = useNavigate();
    const { carService } = useCar(-1);
    const [newCar, setNewCar] = useState(null)
    const [oldCar, setOldCar] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const [isFirstValidated, setIsFirstValidated] = useState(false)

    const [validates, setValidates] = useState({})
    const { app } = useContext(AppContext);

    const validateCar = (car) => {
        const messages = {};

        if (!car || typeof car !== 'object') {
            setValidates(messages);
            return false;
        }

        const dealerPrice = Number(car[activeField]);
        if (!Number.isFinite(dealerPrice) || dealerPrice <= 0) {
            messages[activeField] = {
                message: t(fieldConfig.validationKey, {
                    defaultValue: fieldConfig.defaultValidationMessage,
                }),
            };
        }

        const isValid = Object.keys(messages).length === 0;
        setValidates(messages);
        return isValid;
    };

    useEffect(() => {
        if (isFirstValidated === true) {
            if (newCar) {
                const isValidate = validateCar(newCar)
            }
        }
    }, [newCar, isFirstValidated]);

    useEffect(() => {
   
            carService.getCarById(Number(id))
                .then(car => {
                    if (car) {
                        const editedCar = carService.initData(car)
                        setNewCar(editedCar)
                        setOldCar(editedCar)
                        setIsLoading(false);
                    } else {
                    }
                })
                .catch(error => {
                    console.error("Error fetching the car:", error);
                }); 
    }, []);

    if (isLoading || !newCar || !oldCar) {
        return <div>Loading...</div>;
    }

 
    const operateHandle = () => {

        let isValidate = validateCar(newCar)
 
        if (isValidate === true) {
            var updatedCar = {}

            updatedCar = {
                    ...newCar
            };

            delete updatedCar.searchedClients;
            delete updatedCar.transport_price;
 
            const successMessage = "წარმატებით დაემატა";

            
            if (!newCar || typeof newCar !== 'object') {
                console.error('Error: Invalid car data');
                app.setError('შეცდომა: არასწორი ავტომობილის მონაცემები');
                return;
            }
 
            carService.updateCarPage(updatedCar)
                .then(data => {
                    app.setOk(successMessage); 
                    navigate('/dealer/car/'+ id);
                    window.location.reload();

                    // navigate('/finances');
                })
                .catch(errorMessage => {
                    console.error('შეცდომა:', errorMessage);
                    if (errorMessage.includes("email")) {
                        app.setError("შეცდომა: ესეთი ელ-ფოსტით უკვე არსებობს მომხმარებელი");
                    } else if (errorMessage.includes("mobile")) {
                        app.setError("შეცდომა: ესეთი მობილურით უკვე არსებობს მომხმარებელი");
                    } else if (errorMessage.includes("unique vin")) {
                        app.setError("შეცდომა: ესეთი VIN უკვე არსებობს");
                    } else {
                        app.setError("შეცდომა: " + errorMessage);
                    }
                });

        } else {
            setIsFirstValidated(true)
        }
    };

 
    const handleClose = () => { 
        setClientInfoModal(false);   
    };



  function convertToInt(str) {
    const num = parseInt(str, 10);
    return isNaN(num) ? 0 : num;
  }

  const handleKeyPress = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    const regex = /^[0-9]+$/;

    if (!regex.test(keyValue)) {
      event.preventDefault();
    }
  };

  const handleFocus = (e) => {
    if (e.target.value === "0") {
      setNewCar({
        ...newCar,
        [e.target.name]: "",
      });
    }
  };

  const handleBlur = (e) => {
    if (e.target.value === "") {
      let val = convertToInt(0);
      setNewCar({
        ...newCar,
        [e.target.name]: val,
      });
    }
  };


    const handleDealerCommissionChange = (event) => {
        let val = convertToInt(event.target.value);
        let newState = {
            ...newCar,
            [event.target.name]: val,
        };
        setNewCar(newState);
    };

    const fieldError = validates[activeField];

    return (
        <>
            <button className={ cl.addClientBTN } style={{position: 'absolute'}} onClick={() => setClientInfoModal(true)}>
                {t('Update')}
            </button>


            <Modal key={`${id}-${activeField}`} size="small" isOpen={clientInfoModal} onClose={handleClose}>
                <div className={cl.modalHead}>
                    <h3>{t('Update')}</h3>
                </div>  

                <div className={cl.newClientClass}>
                    {Number(oldCar[activeField]) === 0 && (
                        <div className={cl.groupPrice}>
                            <label className={cl.leftLabel}>{t(fieldConfig.label)}</label>
                            <div className={cl.rightInput}>
                                <div
                                    className={Form.priceInput}
                                    style={fieldError ? { borderColor: '#e11d48' } : undefined}
                                >
                                    <div className={Form.priceCurrency}>USD</div>
                                    <input
                                        type="text"
                                        onFocus={handleFocus}
                                        onBlur={handleBlur}
                                        onKeyPress={handleKeyPress}
                                        name={activeField}
                                        className={Form.input}
                                        style={fieldError ? { borderLeft: '1px solid #e11d48' } : undefined}
                                        onChange={handleDealerCommissionChange}
                                        value={newCar[activeField]}
                                        min="0"
                                    />
                                    <div
                                        className={Form.hundred}
                                        style={fieldError ? { borderLeft: '1px solid #e11d48' } : undefined}
                                    >.00</div>
                                </div>
                                {fieldError && (
                                    <div className={cl.errorMsg}>{fieldError.message}</div>
                                )}
                            </div>
                        </div>
                    )}  

                    <span onClick={operateHandle} style={{ marginLeft: 'auto' }} className={cl.btnPrimary}>{t('Save')}</span>

                </div>
            </Modal> 


        </>
    );
};

export default DealerComision;
